var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.293019 6C0.235068 6.00001 0.178416 5.98283 0.130228 5.95064C0.0820404 5.91845 0.044482 5.87269 0.0223038 5.81915C0.000125496 5.76561 -0.00567626 5.7067 0.00563234 5.64986C0.016941 5.59303 0.0448519 5.54082 0.0858347 5.49985L5.49981 0.0858193C5.55476 0.0308701 5.62929 0 5.707 0C5.78471 0 5.85923 0.0308701 5.91418 0.0858193C5.96913 0.140769 6 0.215296 6 0.293005C6 0.370715 5.96913 0.445242 5.91418 0.500192L0.500203 5.91422C0.47302 5.94146 0.440724 5.96306 0.405169 5.97778C0.369614 5.9925 0.331501 6.00005 0.293019 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70698 6C5.6685 6.00005 5.63039 5.9925 5.59483 5.97778C5.55928 5.96306 5.52698 5.94146 5.4998 5.91422L0.0858185 0.500192C0.0308699 0.445242 0 0.370715 0 0.293005C0 0.215296 0.0308699 0.140769 0.0858185 0.0858193C0.140767 0.0308701 0.215294 0 0.293003 0C0.370712 0 0.445238 0.0308701 0.500187 0.0858193L5.91417 5.49985C5.95515 5.54082 5.98306 5.59303 5.99437 5.64986C6.00568 5.7067 5.99987 5.76561 5.9777 5.81915C5.95552 5.87269 5.91796 5.91845 5.86977 5.95064C5.82158 5.98283 5.76493 6.00001 5.70698 6V6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossTag);
export default __webpack_public_path__ + "static/media/crossTag.80111fb2d377a46efb0aaccde998d250.svg";
export { ForwardRef as ReactComponent };